import { datadogLogs } from "@datadog/browser-logs";
import { BoltIcon, GlobeAltIcon } from "@heroicons/react/24/solid";
import { CalendarIcon, formatDateWithOrdinal } from "common";
import Footer from "common/src/components/Footer";
import { useParams } from "react-router-dom";
import { useEnsName } from "wagmi";
import { ReactComponent as GithubIcon } from "../../assets/github-logo.svg";
import { ReactComponent as TwitterIcon } from "../../assets/twitter-logo.svg";
import { useRoundById } from "../../context/RoundContext";
import Breadcrumb from "../common/Breadcrumb";
import Navbar from "../common/Navbar";
import RoundEndedBanner from "../common/RoundEndedBanner";
import { ApplicationFormAnswers, DescriptionTitle, Detail, DetailSummary, Header, ProjectTitle } from "./common";
import { ProjectCard } from "../discovery/IUCApplications";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const IAM_SERVER = "did:key:z6MkghvGHLobLEdj1bgRLhS4LPGJAvbMA1tn2zcRyqmYU5LC";
export default function ViewProjectDetails() {
  var _round$approvedProjec, _round$approvedProjec2;
  datadogLogs.logger.info("====> Route: /round/:chainId/:roundId/:applicationId/registry/:registryAddress/project/:id");
  datadogLogs.logger.info(`====> URL: ${window.location.href}`);
  const {
    chainId,
    roundId,
    applicationId,
    registryAddress,
    id
  } = useParams();
  const fullId = [chainId, registryAddress, id].join(":");

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const {
    round,
    isLoading
  } = useRoundById(chainId, roundId);
  const projectToRender = round === null || round === void 0 ? void 0 : (_round$approvedProjec = round.approvedProjects) === null || _round$approvedProjec === void 0 ? void 0 : _round$approvedProjec.find(project => project.grantApplicationId === applicationId);
  const relatedApplications = (round === null || round === void 0 ? void 0 : (_round$approvedProjec2 = round.approvedProjects) === null || _round$approvedProjec2 === void 0 ? void 0 : _round$approvedProjec2.filter(project => {
    var _project$projectMetad;
    return (project === null || project === void 0 ? void 0 : (_project$projectMetad = project.projectMetadata) === null || _project$projectMetad === void 0 ? void 0 : _project$projectMetad.id) === fullId;
  })) || [];
  const {
    projectMetadata
  } = projectToRender || {};
  const currentTime = new Date();
  const isAfterRoundEndDate = round && round.roundEndTime <= currentTime;
  const isBeforeRoundEndDate = round && round.roundEndTime > currentTime;
  const breadCrumbs = [{
    name: "Explorer Home",
    path: "/"
  }, {
    name: "Project Details",
    path: `/round/${chainId}/${roundId}/${applicationId}/registry/${registryAddress}/project/${id}`
  }];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Navbar, {}), isAfterRoundEndDate && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(RoundEndedBanner, {})
    }), /*#__PURE__*/_jsxs("div", {
      className: "relative top-16 lg:top-24 lg:mx-20 h-screen px-4 py-7",
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex flex-col pb-6",
        "data-testid": "bread-crumbs",
        children: /*#__PURE__*/_jsx(Breadcrumb, {
          items: breadCrumbs
        })
      }), /*#__PURE__*/_jsx("main", {
        className: "flex flex-col items-center",
        children: !isLoading && projectToRender && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Header, {
            bannerHash: projectMetadata === null || projectMetadata === void 0 ? void 0 : projectMetadata.bannerImg,
            logoHash: projectMetadata === null || projectMetadata === void 0 ? void 0 : projectMetadata.logoImg
          }), /*#__PURE__*/_jsx("div", {
            className: "flex flex-col md:flex-row xl:max-w-[1800px] w-full",
            children: /*#__PURE__*/_jsxs("div", {
              className: "grow",
              children: [/*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx(ProjectTitle, {
                  title: (projectMetadata === null || projectMetadata === void 0 ? void 0 : projectMetadata.title) || ""
                }), /*#__PURE__*/_jsx(AboutProject, {
                  projectToRender: projectToRender
                })]
              }), /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx(DescriptionTitle, {}), /*#__PURE__*/_jsx(Detail, {
                  text: (projectMetadata === null || projectMetadata === void 0 ? void 0 : projectMetadata.description) || "",
                  testID: "project-metadata"
                }), /*#__PURE__*/_jsx(ApplicationFormAnswers, {
                  answers: projectToRender.grantApplicationFormAnswers
                }), relatedApplications && /*#__PURE__*/_jsxs("div", {
                  className: "border-t-2 pt-4 mt-4",
                  children: [/*#__PURE__*/_jsx("h1", {
                    className: "text-2xl mb-4 font-thin text-black",
                    children: "Related Applications"
                  }), /*#__PURE__*/_jsx("div", {
                    className: "flex gap-5 justify-around md:justify-start flex-row flex-wrap w-full",
                    children: relatedApplications === null || relatedApplications === void 0 ? void 0 : relatedApplications.map((project, index) => /*#__PURE__*/_jsx(ProjectCard, {
                      project: project,
                      roundRoutePath: `/round/${chainId}/${roundId}`,
                      isBeforeRoundEndDate: isBeforeRoundEndDate,
                      roundId: roundId || ""
                    }, index))
                  })]
                })]
              })]
            })
          })]
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "my-11",
        children: /*#__PURE__*/_jsx(Footer, {})
      })]
    })]
  });
}
function AboutProject(props) {
  var _projectToRender$reci, _projectToRender$proj, _projectToRender$proj2;
  const {
    projectToRender
  } = props;
  const projectRecipient = projectToRender.recipient.slice(0, 6) + "..." + projectToRender.recipient.slice(-4);
  const {
    data: ensName
  } = useEnsName({
    // @ts-expect-error Temp until viem
    address: (_projectToRender$reci = projectToRender.recipient) !== null && _projectToRender$reci !== void 0 ? _projectToRender$reci : ""
  });
  const projectWebsite = projectToRender === null || projectToRender === void 0 ? void 0 : (_projectToRender$proj = projectToRender.projectMetadata) === null || _projectToRender$proj === void 0 ? void 0 : _projectToRender$proj.website;
  const projectTwitter = projectToRender.projectMetadata.projectTwitter;
  const userGithub = projectToRender.projectMetadata.userGithub;
  const projectGithub = projectToRender.projectMetadata.projectGithub;
  const date = new Date((_projectToRender$proj2 = projectToRender.projectMetadata.createdAt) !== null && _projectToRender$proj2 !== void 0 ? _projectToRender$proj2 : 0);
  const formattedDateWithOrdinal = `Created on: ${formatDateWithOrdinal(date)}`;
  return /*#__PURE__*/_jsxs("div", {
    className: "grid grid-cols-1 sm:grid-cols-2 border-b-2 pt-2 pb-6",
    children: [projectRecipient && /*#__PURE__*/_jsxs("span", {
      className: "flex items-center mt-4 gap-1",
      children: [/*#__PURE__*/_jsx(BoltIcon, {
        className: "h-4 w-4 mr-1 opacity-40"
      }), /*#__PURE__*/_jsx(DetailSummary, {
        text: `${ensName ? ensName : projectRecipient}`,
        testID: "project-recipient",
        sm: true
      })]
    }), projectWebsite && /*#__PURE__*/_jsxs("span", {
      className: "flex items-center mt-4 gap-1",
      children: [/*#__PURE__*/_jsx(GlobeAltIcon, {
        className: "h-4 w-4 mr-1 opacity-40"
      }), /*#__PURE__*/_jsx("a", {
        href: projectWebsite,
        target: "_blank",
        rel: "noreferrer",
        className: "text-base font-normal text-black",
        children: /*#__PURE__*/_jsx(DetailSummary, {
          text: `${projectWebsite}`,
          testID: "project-website"
        })
      })]
    }), projectTwitter && /*#__PURE__*/_jsxs("span", {
      className: "flex items-center mt-4 gap-1",
      children: [/*#__PURE__*/_jsx(TwitterIcon, {
        className: "h-4 w-4 mr-1 opacity-40"
      }), /*#__PURE__*/_jsx("a", {
        href: `https://twitter.com/${projectTwitter}`,
        target: "_blank",
        rel: "noreferrer",
        className: "text-base font-normal text-black",
        children: /*#__PURE__*/_jsx(DetailSummary, {
          text: `@${projectTwitter}`,
          testID: "project-twitter"
        })
      })]
    }), projectToRender.projectMetadata.createdAt && /*#__PURE__*/_jsxs("span", {
      className: "flex items-center mt-4 gap-1",
      children: [/*#__PURE__*/_jsx(CalendarIcon, {
        className: "h-4 w-4 mr-1 opacity-80"
      }), /*#__PURE__*/_jsx(DetailSummary, {
        text: `${formattedDateWithOrdinal}`,
        testID: "project-createdAt"
      })]
    }), userGithub && /*#__PURE__*/_jsxs("span", {
      className: "flex items-center mt-4 gap-1",
      children: [/*#__PURE__*/_jsx(GithubIcon, {
        className: "h-4 w-4 mr-1 opacity-40"
      }), /*#__PURE__*/_jsx("a", {
        href: `https://github.com/${userGithub}`,
        target: "_blank",
        rel: "noreferrer",
        className: "text-base font-normal text-black",
        children: /*#__PURE__*/_jsx(DetailSummary, {
          text: `${userGithub}`,
          testID: "user-github"
        })
      })]
    }), projectGithub && /*#__PURE__*/_jsxs("span", {
      className: "flex items-center mt-4 gap-1",
      children: [/*#__PURE__*/_jsx(GithubIcon, {
        className: "h-4 w-4 mr-1 opacity-40"
      }), /*#__PURE__*/_jsx("a", {
        href: `https://github.com/${projectGithub}`,
        target: "_blank",
        rel: "noreferrer",
        className: "text-base font-normal text-black",
        children: /*#__PURE__*/_jsx(DetailSummary, {
          text: `${projectGithub}`,
          testID: "project-github"
        })
      })]
    })]
  });
}